module.exports = __webpack_public_path__ + "static/media/foto10.2f826381.JPG";